import React from 'react';
import $ from 'jquery';

export default function checkboxFilter(options) {
  return (
    <div className="checkbox-filter">
      <div>Show:</div>
      {options.map((option) => (
        <div className="top-options" key={option.key}>
          <label>
            <input
              data-id={`brtable-colsort-filter-checkbox-option-${option.key}`}
              name={option.key}
              type="checkbox"
              onClick={(e) => {
                const otherCheckboxes = $(e.target).closest('.top-options').siblings().find('input');
                const childCheckboxes = $(e.target).closest('label').siblings('.child-options').find('input');
                if ($(e.target).prop('checked')) {
                  $(e.target).toggleClass('partial', false);
                  otherCheckboxes.toggleClass('partial', false);
                  otherCheckboxes.prop('checked', false);
                  childCheckboxes.prop('checked', true);
                } else {
                  childCheckboxes.prop('checked', false);
                }
              }}
              defaultChecked={option.isDefault}
            />
            {option.text}
          </label>
          <div
            data-id={`brtable-colsort-filter-checkbox-sub-options-${option.key}`}
            className="child-options"
            onClick={(e) => {
              const otherCheckboxes = $(e.target).closest('.top-options').siblings().find('input');
              const parentCheckbox = $(e.target).closest('.child-options').siblings('label').find('input');
              const targetCheckbox = $(e.target).is(':checkbox') ? $(e.target) : $(e.target).children(':checkbox');
              if (targetCheckbox[0]) {
                if (targetCheckbox.prop('checked')) {
                  otherCheckboxes.prop('checked', false);
                  if (targetCheckbox.closest('.child-options').find(':checked').length >= option.childs.length) {
                    parentCheckbox.prop('checked', true);
                    parentCheckbox.toggleClass('partial', false);
                  } else {
                    parentCheckbox.prop('checked', false);
                    parentCheckbox.toggleClass('partial', true);
                  }
                } else {
                  parentCheckbox.prop('checked', false);
                  if (targetCheckbox.closest('.child-options').find(':checked').length === 0) {
                    parentCheckbox.toggleClass('partial', false);
                  } else {
                    parentCheckbox.toggleClass('partial', true);
                  }
                }
              }
            }}
          >
            {option.childs
              && option.childs.map((childOp) => (
                <label key={childOp.key}>
                  <input
                    data-id={`brtable-colsort-filter-checkbox-sub-option-${childOp.key}`}
                    name={childOp.key}
                    type="checkbox"
                    defaultChecked={option.isDefault}
                  />
                  {childOp.text}
                </label>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
}
